import { useController } from "react-hook-form";
import { FieldWrapper } from "../FieldWrapper/FieldWrapper";
import { SelectMultipleField, SelectMultipleFieldProps } from "./SelectMultipleField";

export interface FormSelectMultipleProps
    extends Pick<
        SelectMultipleFieldProps,
        "helperText" | "isDisabled" | "label" | "name" | "options" | "placeholder"
    > {
    defaultValue?: string[];
}

export function FormSelectMultiple({
    defaultValue = [],
    helperText,
    isDisabled,
    label,
    name,
    options,
    placeholder,
}: FormSelectMultipleProps) {
    const { field, fieldState } = useController({
        name,
        defaultValue,
    });
    return (
        <FieldWrapper name={field.name}>
            <SelectMultipleField
                helperText={helperText}
                inputRef={field.ref}
                isDisabled={isDisabled}
                isError={!!fieldState.error}
                label={label}
                name={field.name}
                onChange={field.onChange}
                options={options}
                placeholder={placeholder}
                value={field.value}
            />
        </FieldWrapper>
    );
}
